import React, {useEffect, useState} from 'react'
import {Link, useNavigate} from 'react-router-dom'
import {Card} from 'react-bootstrap'

import {api} from 'landing-page/helpers'
import {useApi} from 'landing-page/hooks/useApi'

import Container from '../../common/Container'
import SectionHeader from '../SectionHeader'

import styles from './TalentaCards.module.scss'

interface TalentaCardsProps {
  items?: TalentaCardItem[]
  autoFetch?: boolean
  carouselType?: string
}

interface TalentaCardItem {
  id: string
  title_id: string
  deskripsi_id: string
  link_text_id: string
  link_url_id: string
  image_id: string
  is_active: string
}

const TalentaCards: React.FC<TalentaCardsProps> = ({
  items: propItems = [],
  autoFetch = true,
  carouselType = 'header_2',
}) => {
  const navigate = useNavigate()

  const [talentaCardsData, setTalentaCardsData] = useState<TalentaCardItem[]>(propItems)

  const {data, execute: fetchTalentaCardsData} = useApi(api.getTalentaCards.bind(api))

  const handleClickCard = (id: string, link_url_id: string) => {
    if (id === 'tesis-dan-disertasi') {
      navigate(`/content`)
      localStorage.setItem('selectedCard', '0')
    }

    if (id === 'lowongan-pekerjaan') {
      navigate('/auth')
      localStorage.setItem('selectedCard', '1')
    }

    if (id === 'pana') {
      navigate('/auth')
      localStorage.setItem('selectedCard', '2')
    }

    if (id === 'tracer-alumni') {
      window.open(link_url_id, '_blank')
      localStorage.setItem('selectedCard', '3')
    }
  }

  useEffect(() => {
    if (autoFetch && propItems.length === 0) {
      fetchTalentaCardsData({tipe: carouselType})
    } else if (propItems.length > 0) {
      setTalentaCardsData(propItems)
    }
  }, [autoFetch, propItems.length, carouselType])

  useEffect(() => {
    if (data?.data) {
      const filteredItems = data.data?.data?.filter(
        (item: TalentaCardItem) => item.is_active === '1'
      )
      setTalentaCardsData(filteredItems)
    }
  }, [data])

  return (
    <Container>
      <SectionHeader
        autoFetch={true}
        dataType='header_2'
        withDescriptionAnimation={true}
        withTitleAnimation={false}
      />

      <div className='row d-flex align-item-center flex-wrap gap-4 gap-md-0'>
        {talentaCardsData.map((item) => (
          <div
            className='col-md-3'
            key={item.id}
            onClick={() => handleClickCard(item.id, item.link_url_id)}
          >
            <Card className={`border-0 shadow-sm rounded-4 card-hover ${styles.talentaCard}`}>
              <Card.Body className='d-flex flex-column'>
                <Card.Img src={item.image_id} className={styles.talentaCardImage} />
                <div className='d-flex flex-column gap-2'>
                  <Card.Title as='h4' className='fw-bold'>
                    {item.title_id}
                  </Card.Title>
                  <Card.Text className='text-muted'>{item.deskripsi_id}</Card.Text>
                </div>
                <div className='d-flex mt-auto'>
                  <div className='text-primary fs-4 fw-bold d-flex align-items-center gap-2 card-link'>
                    {item.link_text_id}
                    <i className='bi bi-arrow-right fs-4 text-primary arrow-hover'></i>
                  </div>
                </div>
              </Card.Body>
            </Card>
          </div>
        ))}
      </div>
    </Container>
  )
}

export default TalentaCards
